<template>
  <a v-editable="blok" :href="getLinkFieldUrl(blok?.url)" :class="['btn', 'btn-' + blok.theme, !hasIconName && blok.icon && `btn-icon-${blok.icon}`, hasIconName && `btn-has-icon`]" :aria-label="blok.label" :target="blok.url?.target" role="button">{{ blok.label }} <UIcon v-if="hasIconName" :name="blok.iconName" class="btn-icon" /> </a>
</template>

<script setup>
  const props = defineProps({ blok: Object });

  const hasIconName = computed(() => props.blok.iconName && props.blok.iconName.length > 0);
</script>
